import BaseView from '../../../base-view';

export default BaseView.extend({
	events: {
		'change input[type="checkbox"]': 'onSelectAllChange',
		'click .js-alerts-confirm': 'onButtonClick',
		'click .js-alerts-deny': 'onButtonClick'
	},

	alertModel: null,

	initialize: function() {
		// reference elements
		this.alertsCount = this.query('.js-alerts-count');
		this.alertsSelectedCount = this.query('.js-selected-alerts-count');
		this.alertTimer = this.query('.js-alert-timer');

		this.checkbox = this.query('input[type="checkbox"]');
		this.buttonConfirm = this.query('.js-alerts-confirm');
		this.buttonDeny = this.query('.js-alerts-deny');

		// collection listeners
		this.listenTo(this.collection, 'add', this.onAlertAdded);
		this.listenTo(this.collection, 'change:IsSelected', this.onAlertSelectedChange);

		// set model to listen to
		this.setAlertModel();

		// update time
		this.updateTimer();
	},

	/**
	 * Alert added to the collection handler
	 * updates UI
	 **/
	onAlertAdded: function(model) {
		this.updateAlertCount();
		this.setAlertModel();
		this.updateTimer();
	},

	/**
	 * Select or deselect all alerts in the collection
	 **/
	onSelectAllChange: function(e) {
		var selected = e.target.checked;

		this.collection.forEach(function(model) {
			model.set('IsSelected', selected);
		});
	},

	/**
	 * Alert IsSelected change handler
	 * updates UI
	 **/
	onAlertSelectedChange: function(model, isSelected) {
		this.updateSelectCount();
		this.setCheckboxState();
		this.setButtonStates();
	},

	/**
	 * Form button handlers, can be deny or confirm
	 * gets the href from the button and dispatches an event with the URL
	 **/
	onButtonClick: function(e) {
		e.preventDefault();

		// get form action from button href
		var btn = e.target,
			action = btn.getAttribute('href');

		if (!btn.classList.contains('is-disabled')) {
			// trigger submit events
			this.trigger('alerts:submit', action);
		}
	},

	/**
	 * set the model to listen to for updating the counter
	 **/
	setAlertModel: function() {
		// collection is sorted
		var firstAlert = this.collection.at(0);

		// no need to continue
		if (!firstAlert || firstAlert === this.firstAlert) {
			return;
		}

		// remove previous listener
		// note: omitting event removes listeners from collection as well
		this.stopListening(this.firstAlert, 'change:MinutesLeft');

		// switch models
		this.firstAlert = firstAlert;
		this.listenTo(this.firstAlert, 'change:MinutesLeft', this.updateTimer);
	},

	/**
	 * Update the checked state of the checkbox
	 * only checked when all alerts are checked
	 **/
	setCheckboxState: function() {
		var allSelected = this.collection.where({IsSelected: true}).length === this.collection.length;
		this.checkbox.checked = allSelected;
	},

	/**
	 * Set button (deny, confirm) state
	 * only enable when one or more alerts are selected
	 **/
	setButtonStates: function() {
		var isDisabled = this.collection.where({IsSelected: true}).length === 0;
		this.buttonConfirm.classList.toggle('is-disabled', isDisabled);
		this.buttonDeny.classList.toggle('is-disabled', isDisabled);
	},

	/**
	 * Update timer with time left for first alert
	 **/
	updateTimer: function() {
		// no model to get data from
		if (!this.firstAlert) {
			return;
		}

		// get minutes en determine if class should be set
		var minutesLeft = this.firstAlert.get('MinutesLeft'),
			blink = minutesLeft <= 1;

		// update timer and add/remove class
		this.alertTimer.innerHTML = minutesLeft + 'm';
		this.alertTimer.classList.toggle('blink', blink);
	},

	/**
	 * Update number of alerts
	 **/
	updateAlertCount: function() {
		this.alertsCount.textContent = this.collection.length;
	},

	/**
	 * Update count of selected alerts
	 **/
	updateSelectCount: function() {
		var numSelected = this.collection.where({IsSelected: true}).length;
		this.alertsSelectedCount.textContent = numSelected;
	}

});

